/** CPF é guardado só com dígitos (ver decisão registrada: evita divergência de formato
 * numa eventual comparação/importação futura) — a máscara é só visual, na digitação e na
 * exibição. */
export function apenasDigitos(valor: string): string {
  return valor.replace(/\D/g, '');
}

export function formatarCPF(valor: string): string {
  const digitos = apenasDigitos(valor).slice(0, 11);
  return digitos
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

/** Pretensão Salarial fica como moeda formatada (decisão registrada: ao contrário do CPF,
 * aqui o texto formatado é o próprio dado salvo). Máscara "de trás pra frente": cada
 * dígito digitado entra nos centavos, empurrando o resto pra esquerda. */
export function formatarMoeda(valor: string): string {
  const digitos = apenasDigitos(valor);
  if (!digitos) return '';
  const centavos = parseInt(digitos, 10);
  return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/** `<input type="date">` sempre grava/lê no formato ISO (AAAA-MM-DD) — só reordena pra
 * exibição, não muda o que é salvo. */
export function formatarDataBR(valorIso: string): string {
  const partes = valorIso.split('-');
  if (partes.length !== 3) return valorIso;
  const [ano, mes, dia] = partes;
  return `${dia}-${mes}-${ano}`;
}

/** Confere os dois dígitos verificadores do CPF (e recusa sequências tipo 111.111.111-11). */
export function cpfValido(valor: string | null | undefined): boolean {
  const cpf = apenasDigitos(valor ?? '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  const digito = (base: string) => {
    const soma = base.split('').reduce((acc, d, i) => acc + Number(d) * (base.length + 1 - i), 0);
    const resto = (soma * 10) % 11;
    return resto === 10 ? 0 : resto;
  };
  return digito(cpf.slice(0, 9)) === Number(cpf[9]) && digito(cpf.slice(0, 10)) === Number(cpf[10]);
}

export function formatarCEP(valor: string): string {
  const digitos = apenasDigitos(valor).slice(0, 8);
  return digitos.replace(/(\d{5})(\d)/, '$1-$2');
}
